// extracted by mini-css-extract-plugin
export default {"panel_wrap":"ControlPanel_panel_wrap__OViLY"};